import { API_AUTH } from "./common";

const BanHangTraGopApi = {
  // list: ({
  //   dateFrom,
  //   dateTo,
  //   code,
  //   customerName,
  //   address,
  //   noteTaiSan,
  //   status,
  //   debt,
  //   userName,
  //   pageIndex,
  //   pageSize,
  //   taiSan = 0,
  //   dongtungay,
  //   dongdenngay,
  // }) =>
  //   API_AUTH.get(
  //     `quanlychovay/danh-sach-tra-gop?dateFrom=${dateFrom}&dateTo=${dateTo}&code=${code}&customerName=${customerName}&address=${address}&noteTaiSan=${noteTaiSan}&status=${status}&debt=${debt}&userName=${userName}&taiSan=${taiSan}&dongtungay=${dongtungay}&dongdenngay=${dongdenngay}&pageIndex=${pageIndex}&pageSize=${pageSize}`,
  //     {}
  //   ),

  list: ({
    dateFrom,
    dateTo,
    code,
    customerName,
    address,
    noteTaiSan,
    status,
    debt,
    userName,
    pageIndex,
    pageSize,
    taiSan = 0,
    dongtungay,
    dongdenngay,
  }) =>
    API_AUTH.get(
      `banhangtragop/lstHopDongBanHangTraGpp?dateFrom=${dateFrom}&dateTo=${dateTo}&code=${code}&customerName=${customerName}&address=${address}&noteTaiSan=${noteTaiSan}&status=${status}&debt=${debt}&userName=${userName}&taiSan=${taiSan}&dongtungay=${dongtungay}&dongdenngay=${dongdenngay}&pageIndex=${pageIndex}&pageSize=${pageSize}`,
      {}
    ),
  addAndEdit: ({ ChoVay, SanPhamTraGop, Customer, IsChoDuyet = false }) =>
    API_AUTH.post("banhangtragopy/AddOrUpdateHopDong", {
      ChoVay,
      SanPhamTraGop,
      Customer,
      IsChoDuyet,
    }),
  daoHo: ({ ChoVay }) =>
    API_AUTH.post("quan-ly-cho-vay/dao-ho", {
      ...ChoVay,
    }),
  //
  listCauHinhGoiTraGop: ({ sSearch, bStatus, iPageIndex, iPageSize }) =>
    API_AUTH.get(
      `banhangtragop/GetDanhSachSanPham?sSearch=${sSearch}&bStatus=${bStatus}&iPageIndex=${iPageIndex}&iPageSize=${iPageSize}`,
      {}
    ),
  addCauHinhGoiTraGop: (params) =>
    API_AUTH.post("banhangtragop/AddOrEditSanPhamTraGop", params),
  xoaSanPham: (IdSanPham) => {
    return API_AUTH.post(
      `banhangtragop/DeleteSanPham?IdSanPham=${IdSanPham}`,
      {}
    );
  },
  addCauHinhGoiSanPham: (params) =>
    API_AUTH.post("banhangtragop/AddOrEditGoiSanPham", params),
  xoaGoiSanPham: (IdGoi) => {
    return API_AUTH.post(`banhangtragop/DeleteGoiSanPham?IdGoi=${IdGoi}`, {});
  },
  listSanPhamGoi: (sSearch, bStatus, iPageIndex, iPageSize) =>
    API_AUTH.get(
      `banhangtragop/GetDanhSachSanPham?sSearch=${sSearch}&bStatus=${bStatus}&iPageIndex=${iPageIndex}&iPageSize=${iPageSize}`,
      {}
    ),

  getAllQuyen: () => {
    return API_AUTH.get(`phanquyen/GetAllQuyen`, {});
  },
};

export default BanHangTraGopApi;
